/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import * as Yup from "yup";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import html2pdf from "html2pdf.js";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import Loader from "../components/loader";
import { useSearchParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import {
  getDocumentDetails,
  signDocument,
} from "../redux/slice/legalDoc/legalAPI";
import "./styles.scss";

function decryptData(incryptedContent) {
  // TO decrypt the document data
  const secretKey = "your-strong-secret-key";
  const decryptedText = CryptoJS.AES.decrypt(
    incryptedContent,
    secretKey
  ).toString(CryptoJS.enc.Utf8);
  return decryptedText;
}

export default function Signature() {
  const sigRef = useRef();
  const dispatch = useDispatch();
  const [htmlData, setHtmlData] = useState();
  const [htmlName, setHtmlName] = useState();
  const [signedPDF, setSignedPDF] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [notFound, setNotFound] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const orgId = searchParams.get("orgid");
  const userId = searchParams.get("userid");
  const documentId = searchParams.get("docid");
  const versionId = searchParams.get("versionid");
  const isSignReq = searchParams.get("isSignatureRequired");

  useEffect(() => {
    // To fetch document details
    let payload = {
      orgId: orgId,
      versionId: versionId,
      documentId: documentId,
    };
    if (orgId && userId && documentId && versionId) {
      setShowLoader(true);
      dispatch(getDocumentDetails(payload))
        .then((response) => {
          setShowLoader(false);
          if (response?.data?.success) {
            setHtmlData(decryptData(response?.data?.data?.fileData));
            setHtmlName(response?.data?.data?.name);
          } else {
            setNotFound(false);
            Swal.fire({
              title: response?.data?.message
                ? response?.data?.message
                : "Something went wrong",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          setShowLoader(false);
          Swal.fire({
            title: error?.message,
            icon: "error",
          });
        });
    }
  }, []);

  useEffect(() => {
    // Only proceed if htmlData is available
    if (htmlData && orgId && userId && documentId && versionId) {
      const documentDiv = document.getElementById("showHTMLData");
  
      if (documentDiv) {
        const documentName = document.createElement("div");
        documentName.className = "heading-class";
        documentName.innerHTML = htmlName;
  
        // Clear any existing content in the div to avoid undefined flicker
        documentDiv.innerHTML = "";
  
        const firstChild = documentDiv.firstChild;
        documentDiv.insertBefore(documentName, firstChild);
  
        // Now insert the actual HTML content
        documentDiv.innerHTML = htmlData;
      }
    }
  }, [htmlData, orgId, userId, documentId, versionId, htmlName]);

  const validationSchema = Yup.object().shape({
    // Sign validations
    sign: Yup.string().required("This field is required"),
  });

  const initialValues = {
    // Initial values of API payload
    orgId: orgId,
    signed: true,
    accepted: true,
    userId: userId,
    docuId: documentId,
    versionId: versionId,
  };

  async function createPDF(signatureData) {
    // Create a temporary container for the HTML content
    const contentContainer = document.createElement("div");
    const documentDiv = document.getElementById("showHTMLData");
    const clonedDocumentDiv = documentDiv.cloneNode(true);
    contentContainer.appendChild(clonedDocumentDiv);
    if (signatureData) {
      // Create a temporary container for the signature
      const signatureDiv = document.createElement("div");
      const signatureImage = document.createElement("img");
      signatureImage.style.width = '100px';
      signatureImage.src = signatureData;
      const signature = document.createElement("div");
      signature.innerHTML = "Signature";
      signatureDiv.appendChild(signatureImage);
      signatureDiv.appendChild(signature);
      contentContainer.appendChild(signatureDiv);
    }
    // Create the PDF element
    const element = contentContainer;
    // PDF style options
    var options = {
      margin: [0.5, 1, 0.5, 1],
      filename: "myfile.pdf",
      text: { type: "txt", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
    try {
      const base64 = await html2pdf()
        .from(element)
        .set(options)
        .output("datauristring");
      setSignedPDF(base64);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  }

  function addNewParam(newValue) {
    // Add params to the url
    const newSearchParams = new URLSearchParams(searchParams);
    if (newSearchParams.has("success")) {
      newSearchParams.set("success", newValue);
    } else {
      newSearchParams.append("success", newValue);
    }
    setSearchParams(newSearchParams);
  }

  const handleSubmit = (values, { resetForm }) => {
    // On click of submit button
    setShowLoader(true);
    const payload = { ...values };
    delete payload["sign"];
    if (isSignReq === "true") {
      delete payload["accepted"];
    } else {
      delete payload["signed"];
    }
    payload["doc"] = signedPDF.split(",")[1];
    dispatch(signDocument(payload))
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.success) {
          Swal.fire({
            title: response?.data?.message,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed) {
              // console.log(JSON.stringify(response.data));
              addNewParam(true);
              window.postMessage(
                JSON.stringify({ type: "dataReceived", ...response?.data }),
                "*"
              );
            }
          });
        } else {
          Swal.fire({
            title: response?.data?.message
              ? response?.data?.message
              : "Something went wrong",
            icon: "error",
          }).then((result) => {
            if (result.isConfirmed) {
              // console.log(JSON.stringify(response.data));
              addNewParam(false);
              window.postMessage(
                JSON.stringify({ type: "dataReceived", ...response?.data }),
                "*"
              );
            }
          });
        }
        if (isSignReq === "true") {
          sigRef.current?.clear();
          resetForm();
        }
      })
      .catch((error) => {
        setShowLoader(false);
        Swal.fire({
          title: error?.message,
          icon: "error",
        }).then((result) => {
          if (result.isConfirmed) {
            // console.log(JSON.stringify(error));
            addNewParam(false);
            window.postMessage(
              JSON.stringify({ type: "dataReceived", ...error }),
              "*"
            );
          }
        });
        if (isSignReq === "true") {
          sigRef.current?.clear();
          resetForm();
        }
      });
  };

  return (
    <div className='container signDoc'>
      {showLoader && <Loader showLoader={showLoader} />}
      {!showLoader && !htmlData && (
        <div className="no-doc">No Document Found</div>
      )}
      {!showLoader && htmlData && orgId && userId && documentId && versionId && notFound ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, setFieldValue, submitCount }) => (
            <Form>
              <div className='box-css mt-5'>
                <div className='form-group'>
                  {/* Div to show the document data */}
                  <div className='form-group' id='showHTMLData' />
                </div>
                {isSignReq === "true" ? (
                  <div className='form-group'>
                    {/* Signature field */}
                    <div className='labelOf'>Signature:</div>
                    <SignatureCanvas
                      penColor='blue'
                      ref={sigRef}
                      canvasProps={{ className: "signature" }}
                      onEnd={() => {
                        createPDF(sigRef.current?.toDataURL("image/png"));
                        setFieldValue(
                          "sign",
                          sigRef.current?.toDataURL()?.split(",")[1]
                        );
                      }}
                    />
                    <span style={{ color: "red" }}>
                      {errors && submitCount && errors.sign ? errors.sign : ""}
                    </span>
                  </div>
                ) : ('')}
              </div>
              <div className='form-group d-flex gap-5 justify-content-center mt-4'>
                {/* Clear signature button */}
                {isSignReq === "true" ? (
                  <><button
                    onClick={() => {
                      sigRef.current?.clear();
                      setFieldValue("sign", "");
                    } }
                  >
                    Clear Signature
                  </button>
                    <button type='submit'>Submit</button></>
                ) : ('')}
                
              </div>
            </Form>
          )}
        </Formik>
      ) : ('')}
    </div>
  );
}